module.exports = __webpack_public_path__ + "img/11.bc331a87.png";